import { Injectable } from '@angular/core';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ItemSetService {
  private apiUrl = '/itemsets';

  constructor(private http: HttpService) { }

  get(query?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;
    return this.http.get(url, query);
  }

  post(
    ownerId: number,
    itemCd: string,
    itemTx: string,
    lotFl: number,
    uselimitFl: number,
    unitId: number,
    amountNr: number,
    janCd: string,
    lengthNr: number,
    widthNr: number,
    heightNr: number,
    volumeNr: number,
    weightNr: number,
    stockunitpriceNr: number,
    arriveunitpriceNr: number,
    shipunitpriceNr: number,
    depositpriceNr: number,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;

    const jsonInput = {
      ownerId: ownerId,
      itemCd: itemCd,
      itemTx: itemTx,
      lotFl: lotFl,
      uselimitFl: uselimitFl,
      unitId: unitId,
      amountNr: amountNr,
      janCd: janCd,
      lengthNr: lengthNr,
      widthNr: widthNr,
      heightNr: heightNr,
      volumeNr: volumeNr,
      weightNr: weightNr,
      stockunitpriceNr: stockunitpriceNr,
      arriveunitpriceNr: arriveunitpriceNr,
      shipunitpriceNr: shipunitpriceNr,
      depositpriceNr: depositpriceNr,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);

  }

  put(ownerId: number,
    itemId: number,
    itemTx: string,
    lotFl: number,
    uselimitFl: number,
    itemunitId: number,
    unitId: number,
    amountNr: number,
    janCd: string,
    lengthNr: number,
    widthNr: number,
    heightNr: number,
    volumeNr: number,
    weightNr: number,
    stockunitpriceNr: number,
    arriveunitpriceNr: number,
    shipunitpriceNr: number,
    depositpriceNr: number,
    updprogramCd: string
  ): Promise<any> {
      const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${itemId}`;

      const jsonInput = {
        ownerId: ownerId,
        itemId: itemId,
        itemTx: itemTx,
        lotFl: lotFl,
        uselimitFl: uselimitFl,
        itemunitId: itemunitId,
        unitId: unitId,
        amountNr: amountNr,
        janCd: janCd,
        lengthNr: lengthNr,
        widthNr: widthNr,
        heightNr: heightNr,
        volumeNr: volumeNr,
        weightNr: weightNr,
        stockunitpriceNr: stockunitpriceNr,
        arriveunitpriceNr: arriveunitpriceNr,
        shipunitpriceNr: shipunitpriceNr,
        depositpriceNr: depositpriceNr,
        updprogramCd: updprogramCd
      };

      return this.http.put(url, jsonInput);
  }

  delete(itemId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${itemId}`;
    return this.http.delete(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/item-set/item-set.service.ts